import React from 'react';

/** Placeholder while hourly chart data loads or layout stabilizes. */
function HourlyGenerationAndDemandChartSkeleton({ visible = false }) {
  return (
    <div
      className={`absolute inset-0 z-20 bg-white rounded ${
        visible ? 'visible' : 'invisible group-[.is-resizing]:visible'
      }`}
      role="status"
      aria-live="polite"
      aria-label={visible ? 'Loading hourly chart' : 'Chart is resizing'}
    >
      <div className="h-full flex flex-col p-3 sm:p-4 animate-pulse">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-2">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div key={i} className="flex items-center gap-1.5">
              <div className="w-2.5 h-2.5 rounded-full bg-gray-200" />
              <div className="h-3 bg-gray-200 rounded" style={{ width: `${40 + (i % 4) * 8}px` }} />
            </div>
          ))}
        </div>
        <div className="flex items-center gap-1 mb-2">
          <span className="text-xs text-gray-400 mr-1">Zoom</span>
          {['1D', '1M', '3M', '6M', '1Y', 'All'].map((label) => (
            <div key={label} className="h-6 bg-gray-200 rounded px-2 min-w-[28px]" />
          ))}
        </div>
        <div className="flex-1 min-h-0 flex flex-col justify-end pt-2">
          <div className="flex-1 flex flex-col justify-end gap-px min-h-[120px]">
            {[12, 18, 15, 20, 12, 10, 8, 5].map((pct, i) => (
              <div
                key={i}
                className="bg-gray-200 rounded-sm w-full"
                style={{ height: `${pct}%` }}
              />
            ))}
          </div>
          <div className="flex justify-between mt-2 px-1">
            {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((m) => (
              <div key={m} className="h-2.5 bg-gray-200 rounded w-5" />
            ))}
          </div>
        </div>
        <div className="h-8 mt-2 bg-gray-100 rounded flex items-center px-1">
          <div className="flex-1 h-4 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
}

export default HourlyGenerationAndDemandChartSkeleton;
